module.exports = __webpack_public_path__ + "img/open_music.eab521e5.svg";